module.exports = __webpack_public_path__ + "websocket.22ab51922fff38661bf1.worker.js"